<template>
    <div class="relative">
        <div class="flex justify-end p-4">
            <button
                @click="openDrawer"
                class="flex items-center rounded border border-blue-500 bg-transparent px-4 py-2 text-blue-500 transition-colors hover:bg-blue-500 hover:text-white"
            >
                <FunnelIcon class="mr-2 h-5 w-5" aria-hidden="true" />
                Filtros
            </button>
        </div>

        <transition name="slide">
            <div
                v-if="isDrawerOpen"
                class="fixed inset-0 z-50 flex justify-end overflow-y-auto"
            >
                <div
                    class="fixed inset-0 bg-[#0C0A14]/60 backdrop-blur-sm"
                    @click="closeDrawer"
                ></div>
                <div
                    class="relative z-10 flex h-full min-h-screen w-80 flex-col border-l border-black/5 bg-white text-gray-900 shadow-2xl dark:border-white/10 dark:bg-[#131022] dark:text-white"
                >
                    <div
                        class="flex h-full flex-col"
                    >
                        <div
                            class="flex items-center justify-between border-b border-black/5 dark:border-white/10 p-4"
                        >
                            <h1
                                class="font-display text-lg font-semibold"
                            >
                                Filtros
                            </h1>

                            <button
                                @click="closeDrawer"
                                class="text-gray-400 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white"
                            >
                                &times;
                            </button>
                        </div>
                        <div
                            class="flex-1 p-4"
                        >
                            <form
                                @submit.prevent="handleFetch"
                                class="flex flex-col space-y-4"
                            >
                                <span class="w-full max-w-md">
                                    Período
                                    <litepie-datepicker
                                        v-model="filters.date"
                                        :formatter="{
                                            date: 'DD/MM/YYYY',
                                            month: 'MMM',
                                        }"
                                        :shortcuts="false"
                                    />
                                </span>

                                <span class="w-full max-w-md">
                                    Status
                                    <multiple-select
                                        :options="statuses"
                                        v-model="filters.status"
                                        placeholder="Status"
                                    />
                                </span>

                                <span class="w-full max-w-md">
                                    Pessoa
                                    <multiple-select
                                        :options="personTypes"
                                        v-model="filters.types"
                                        placeholder="Pessoa"
                                    />
                                </span>

                                <span class="w-full max-w-md">
                                    E-mail
                                    <input
                                        v-model="filters.email"
                                        type="text"
                                        class="text-input"
                                    />
                                </span>

                                <span class="w-full max-w-md">
                                    CPF ou CNPJ
                                    <input
                                        v-model="filters.document"
                                        type="text"
                                        class="text-input"
                                    />
                                </span>

                                <div
                                    class="flex space-x-2 pt-2"
                                >
                                    <submit-button :loading="loading">
                                        Filtrar
                                    </submit-button>
                                    <button
                                        @click.prevent="clearFilters"
                                        :disabled="loading"
                                        type="button"
                                        :class="{
                                            'cursor-not-allowed': loading,
                                        }"
                                        class="flex items-center justify-center rounded-lg border-2 border-indigo-500 bg-transparent px-4 py-1 text-sm font-semibold leading-6 text-indigo-500 transition-colors hover:bg-indigo-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-50 dark:border-indigo-400 dark:text-indigo-400 dark:hover:bg-indigo-500 dark:hover:text-white"
                                    >
                                        Limpar filtros
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { FunnelIcon } from "@heroicons/vue/24/outline";
import MultipleSelect from "../forms/MultipleSelect.vue";
import SubmitButton from "../forms/SubmitButton.vue";

export default {
    components: { MultipleSelect, SubmitButton, FunnelIcon },
    props: {
        loading: { type: Boolean, default: false },
        defaultDates: { type: Array, default: () => [] },
        statuses: { type: Array, default: () => [] },
        personTypes: { type: Array, default: () => [] },
    },
    data() {
        return {
            isDrawerOpen: false,
            filters: {
                date: this.defaultDates,
                status: [],
                types: [],
                email: "",
                document: "",
            },
        };
    },
    methods: {
        openDrawer() {
            this.isDrawerOpen = true;
        },
        closeDrawer() {
            this.isDrawerOpen = false;
        },
        emit() {
            const params = {};
            if (this.filters.date?.length === 2) {
                params.betweenDates = this.filters.date.join(",");
            }
            if (this.filters.status.length) {
                params.status = this.filters.status;
            }
            if (this.filters.types.length) {
                params.types = this.filters.types;
            }
            if (this.filters.email) {
                params.email = this.filters.email;
            }
            if (this.filters.document) {
                params.document = this.filters.document;
            }
            this.$emit("update:modelValue", params);
        },
        handleFetch() {
            this.emit();
            this.isDrawerOpen = false;
            this.$emit("fetch");
        },
        clearFilters() {
            this.filters = {
                date: [],
                status: [],
                types: [],
                email: "",
                document: "",
            };
            this.handleFetch();
        },
    },
};
</script>

<style>
.slide-enter-active,
.slide-leave-active {
    transition: transform 0.3s ease;
}
.slide-enter,
.slide-leave-to {
    transform: translateX(-100%);
}
</style>
